import { useTranslation } from "react-i18next";
import { mainURL } from "../utils/common";

export const DownloadFileByFileStoreId = ({
  fileStoreId,
  label,
  classAdd = true,
}) => {
  const { t } = useTranslation();

  return (
    <a
      className={classAdd ? "nav-link fontSizeClass d-flex align-items-center" : "d-flex align-items-center"}
      href={`${mainURL}/filestore/v1/files/id?fileStoreId=${fileStoreId}&tenantId=km.kolkata`}
    >
      <i className="bi bi-download mr-2"></i>
      {t(label)}
    </a>
  );
};
